import React from 'react';
import { Text } from '@radix-ui/themes';
import 'tailwindcss/tailwind.css';
import '@radix-ui/themes/styles.css';
import roleplayIcon from '../../../../assets/images/roleplay.png';
import { nominationType } from 'components/session-activity/Group_Discussion/GroupDiscussion';

const RpStartPresenter = ({ onPress, nominateType }:any) => {
  let nominator = '';
  if (nominateType === nominationType.GROUP_MEMBERS) {
    nominator = 'Your group members have';
  } else if (nominateType === nominationType.GROUP_LEADER) {
    nominator = 'Your group leader has';
  }

  return (
    <div className="flex flex-1 justify-center items-center">
      <img
        src={roleplayIcon}
        alt="Roleplay"
        className="h-[20vh] w-[35vw] max-h-[150px] max-w-[200px] object-contain"
      />
      <Text
        as="span"
        size="4"
        className="text-white py-[1.5vh] font-[Lato-Regular] text-center w-[60vw] mb-[1vh]"
      >
        {`${nominator} nominated you as Presenter\n\nStart your presentation prep NOW`}
      </Text>
      <button
        onClick={onPress}
        className="bg-[#43A047] rounded-[2vw] py-[1.2vh] px-[7vw] mb-[1vh] shadow-md"
      >
        <Text
          as="span"
          size="3"
          className="text-white font-[Lato-Regular]"
        >
          OK
        </Text>
      </button>
    </div>
  );
};

export default RpStartPresenter;